var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuOnboarding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g557",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.054,
    height: 26.053,
    viewBox: "0 0 26.054 26.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path561",
    d: "M0-682.665H26.054v26.054H0Z",
    transform: "translate(0 682.665)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g559",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g565",
    transform: "translate(0.382 5.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path567",
    d: "M-.7-173.047l2.61-6.615a.4.4,0,0,1,.516-.224l2.076.819a.4.4,0,0,1,.224.516l-2.61,6.615a.4.4,0,0,1-.516.224l-2.076-.819A.4.4,0,0,1-.7-173.047Z",
    transform: "translate(0.729 179.913)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g569",
    transform: "translate(17.339 14.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path571",
    d: "M-34.235-26.379l-1.358-1.047",
    transform: "translate(35.593 27.425)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g573",
    transform: "translate(15.672 16.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path575",
    d: "M-30.435-23.432l-1.208-.93",
    transform: "translate(31.643 24.361)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g577",
    transform: "translate(14.021 18.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path579",
    d: "M-21.69-16.786l-.861-.666",
    transform: "translate(22.551 17.452)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g581",
    transform: "translate(5.452 13.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path583",
    d: "M-8.983-72.729h0A1.009,1.009,0,0,1-9.1-74.151l.943-1.107a1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422l-.943,1.107A1.009,1.009,0,0,1-8.983-72.729Z",
    transform: "translate(9.34 75.614)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g585",
    transform: "translate(6.991 14.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path587",
    d: "M-8.983-72.729h0A1.009,1.009,0,0,1-9.1-74.151l.943-1.107a1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422l-.943,1.107A1.009,1.009,0,0,1-8.983-72.729Z",
    transform: "translate(9.339 75.614)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g589",
    transform: "translate(8.53 16.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path591",
    d: "M-8.983-72.729h0A1.009,1.009,0,0,1-9.1-74.151l.943-1.107a1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422l-.943,1.107A1.009,1.009,0,0,1-8.983-72.729Z",
    transform: "translate(9.34 75.615)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g593",
    transform: "translate(10.069 17.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path595",
    d: "M-8.983-72.729h0A1.009,1.009,0,0,1-9.1-74.151l.943-1.107a1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422l-.943,1.107A1.009,1.009,0,0,1-8.983-72.729Z",
    transform: "translate(9.34 75.614)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g597",
    transform: "translate(3.252 6.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path599",
    d: "M-431.895-185.2l-.507-.374-2.387-1.761-.273-.192a4.876,4.876,0,0,1-4.378-1.494.485.485,0,0,0-.674-.021c-2.113,1.9-3.336,1.411-3.93.847a.608.608,0,0,1,.1-.952,20.859,20.859,0,0,0,2.954-2.37l-.135-.051a5.071,5.071,0,0,0-1.495-.314l-1.4-.078a4.574,4.574,0,0,0-.549,0,2.149,2.149,0,0,1-.967-.162l-1.012-.423-2.481,6.289,1.961,1.237.621.436.8-.94a1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422,1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422,1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422,1.009,1.009,0,0,1,1.422-.117,1.009,1.009,0,0,1,.117,1.422l-.383.449.842.622a1.164,1.164,0,0,0,1.529-.115,1.145,1.145,0,0,0,.1-1.459l.422.312a1.163,1.163,0,0,0,1.56-.148,1.145,1.145,0,0,0,.016-1.5l.237.175a1.163,1.163,0,0,0,1.509-.095,1.145,1.145,0,0,0,.072-1.543l.356.263a1.145,1.145,0,0,0,1.582-.217A1.163,1.163,0,0,0-431.895-185.2Z",
    transform: "translate(449.032 192.549)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g601",
    transform: "translate(8.053 6.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path603",
    d: "M-167.027-6.267l-1.449-.23a1.541,1.541,0,0,0-1.337.437,22.343,22.343,0,0,1-3.56,2.964.608.608,0,0,0-.1.952c.594.564,1.817,1.051,3.93-.847a.485.485,0,0,1,.674.021,4.875,4.875,0,0,0,4.389,1.492l3.4,2.507,2.123-1.364-2.424-6.145-1.473.544a2.545,2.545,0,0,1-1.279.126l-1.125-.178",
    transform: "translate(173.654 6.516)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g605",
    transform: "translate(20.191 5.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path607",
    d: "M-97.028-70.614l-1.006-2.55a.4.4,0,0,0-.516-.224l-2.076.819a.4.4,0,0,0-.224.516l2.61,6.615a.4.4,0,0,0,.516.224l2.076-.819a.4.4,0,0,0,.224-.516l-.949-2.406",
    transform: "translate(100.878 73.416)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuOnboarding);
export default __webpack_public_path__ + "static/media/icon_menu_onboarding.ef4a43758e80d03e52caa0f3112bba96.svg";
export { ForwardRef as ReactComponent };